import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import posthog from 'posthog-js';
import ModalFrame from '../../../../ui/primitives/ModalFrame';
import { usePracticeRoom } from '../../../room/tutorial/practiceRoom';
import { useDirectedPopup } from '../../../../ui/popupDirector/popupDirector';

const SHELL_ICON = '/ui/shell-icon.png';
const QUESTS_ICON = '/ui/daily-quests/daily-quests-map-button-icon.svg';
/** Interpolated into the sentence where the "Hall of Fame" link goes (any word order). */
const LINK_MARK = '⁣HOF⁣';

/**
 * The first time a new owner leaves their house (after the interior tutorial):
 * what to do next, so they don't drift away — pearls, quests, the Hall of Fame.
 */
export default function PostBuyMessageHost() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pending = usePracticeRoom((s) => s.postBuyMessagePending);
  const visible = useDirectedPopup('postBuyMessage', pending);
  if (!visible) return null;

  const close = () => usePracticeRoom.setState({ postBuyMessagePending: false });
  const [before, after = ''] = t("And take your place in the {{hallOfFame}}", { hallOfFame: LINK_MARK }).split(LINK_MARK);

  return (
    <ModalFrame
      isOpen
      onClose={close}
      variant="dialog"
      title={t("Don't get lost!")}
      className="max-w-[360px] rounded-xl border border-white-alpha-10"
    >
      <div className="flex flex-col gap-lg [font-family:Lato,sans-serif] text-[15px] leading-[1.4] text-white">
        <p className="m-0 flex items-center gap-md">
          <img src={SHELL_ICON} alt="" width={26} height={22} className="shrink-0" />
          {t("Keep collecting pearls")}
        </p>
        <p className="m-0 flex items-center gap-md">
          <img src={QUESTS_ICON} alt="" width={26} height={26} className="shrink-0" />
          {t("Complete quests")}
        </p>
        <p className="m-0 flex items-center gap-md">
          <span className="w-[26px] shrink-0 text-center text-[22px]" aria-hidden="true">🏆</span>
          <span>
            {before}
            <button
              type="button"
              className="cursor-pointer border-none bg-transparent p-0 font-bold text-gold underline underline-offset-2"
              onClick={() => {
                posthog.capture('post_buy_message_hall_of_fame');
                close();
                navigate('/top');
              }}
            >
              {t("Hall of Fame")}
            </button>
            {after}
          </span>
        </p>
        <button
          type="button"
          onClick={close}
          className="mt-sm w-full cursor-pointer rounded-pill border-none bg-[image:var(--gradient-reward-action)] px-2xl py-md [font-family:'Rubik_One',sans-serif] text-[16px] text-black"
        >
          {t("Got it")}
        </button>
      </div>
    </ModalFrame>
  );
}
